import * as cartTypes from "./ContextTypes";
const domain = localStorage.getItem("domainType");

export const getCartItemCount = (cartProducts = []) => (
  (Array.isArray(cartProducts) ? cartProducts : []).reduce((total, item) => {
    const quantity = Number(item?.quantity);
    return total + (Number.isFinite(quantity) && quantity > 0 ? quantity : 0);
  }, 0)
);

const getCartTotalPrice = (cartProducts = []) => (
  (Array.isArray(cartProducts) ? cartProducts : []).reduce((total, item) => {
    const itemTotal = Number(item?.totalPrice);
    return total + (Number.isFinite(itemTotal) ? itemTotal : 0);
  }, 0)
);

const withCartTotals = (state, cartProducts) => ({
  ...state,
  cartProducts,
  total_items: getCartItemCount(cartProducts),
  total_price: getCartTotalPrice(cartProducts),
});

const cartSnapshot = (cartProducts = []) => {
  try {
    return JSON.stringify(cartProducts);
  } catch {
    return "";
  }
};

const withStableCartTotals = (state, cartProducts) => (
  cartSnapshot(state?.cartProducts || []) === cartSnapshot(cartProducts)
    ? state
    : withCartTotals(state, cartProducts)
);

const cartReducer = (state, { payload, type }) => {
  switch (type) {
    // Add item to the cart
    case cartTypes.ADD_TO_CART:
      return withStableCartTotals(state, [...(state?.cartProducts || []), payload]);

    case cartTypes.UPDATE_TO_CART:
      return withStableCartTotals(state, Array.isArray(payload) ? payload : []);

    // Remove item from the cart
    case cartTypes.REMOVE_FROM_CART:
      let removedItem;
      if (domain === "RETAIL") {
        removedItem = state?.cartProducts.filter(
          (item) => item.product._id !== payload
        );
      } else {
        removedItem = state?.cartProducts.filter(
          (item) => item?.scheduledProduct?._id !== payload
        );
      }
      return withStableCartTotals(state, removedItem);

    case cartTypes.EMPTY_CART:
      return withStableCartTotals(state, []);

    case cartTypes.SET_INCREMENT:
      let incProduct = state.cartProducts.map((curElem) => {
        if (curElem.id === payload) {
          let incQty = curElem.quantity + 1;
          if (incQty >= 10) {
            incQty = 10;
          }
          return {
            ...curElem,
            quantity: incQty,
          };
        } else {
          return curElem;
        }
      });
      return withStableCartTotals(state, incProduct);

    case cartTypes.SET_DECREMENT:
      let decProduct = state.cartProducts.map((curElem) => {
        if (curElem.id === payload) {
          let decQty = curElem.quantity - 1;
          if (decQty <= 1) {
            decQty = 1;
          }
          return {
            ...curElem,
            quantity: decQty,
          };
        } else {
          return curElem;
        }
      });
      return withStableCartTotals(state, decProduct);

    case cartTypes.CART_TOTAL_ITEM:
      let updatedItemVal = getCartItemCount(state.cartProducts);
      return {
        ...state,
        total_items: updatedItemVal,
      };

    case cartTypes.CART_TOTAL_PRICE:
      let updatedItemPrice = getCartTotalPrice(state.cartProducts);
      return {
        ...state,
        total_price: updatedItemPrice,
      };

    default:
      return state;
  }
};

export default cartReducer;
